module.exports = __webpack_public_path__ + "img/StanleyArevalo.f446870e.png";